import React from 'react'
import { ReactComponent as ArrowRolloverUnfoldSvg} from '../../assets/svgs/arrows/Arrow_Rollover_Unfold.svg';

const ArrowRolloverUnfoldIcon = () => (
    <div>
        <ArrowRolloverUnfoldSvg/>
    </div>
)

export default ArrowRolloverUnfoldIcon